import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@app/core/services';
import { loadUser } from '@app/core/store/actions/user.actions';
import { AppState } from '@app/core/store/reducers';
import { Store } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { browserRefresh, resetBrowser } from 'src/main';
import { SetupRequiredComponent } from './admin/components/setup-required.component';
import { UnauthorizedComponent } from './admin/components/unauthorized.component';
import { FooterApplicationComponent } from './layout/footer-application/footer-application.component';
import { HeaderApplicationComponent } from './layout/header-application/header-application.component';
import { SidebarNavComponent } from './layout/sidebar-nav/sidebar-nav.component';
import { PortalComponent } from './portal.component';
import { portalRoutes } from './portal.routes';
import { UserPreferencesComponent } from './preferences/components/user-preferences/user-preferences.component';

@NgModule({
  imports: [SharedModule, CommonModule, RouterModule.forChild(portalRoutes)],
  declarations: [
    FooterApplicationComponent,
    HeaderApplicationComponent,
    SidebarNavComponent,
    PortalComponent,
    UnauthorizedComponent,
    SetupRequiredComponent,
    UserPreferencesComponent
  ]
})
export class PortalModule {
  constructor(private store: Store<AppState>, private router: Router, authService: AuthService) {

    if (browserRefresh) {
      authService.checkUser(true).then(r => {
        if (r) {
          store.dispatch(loadUser());
          resetBrowser();
        }
        else {
          authService.signOut();
        }
      });
    }
  }
}

